import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77fd697f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-tenant-review-agent-details w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Submitted by:", -1))
const _hoisted_3 = { class: "d-flex align-center profile" }
const _hoisted_4 = { class: "info d-flex align-items-center w-100" }
const _hoisted_5 = { class: "details" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "far fa-envelope icon"
}
const _hoisted_9 = {
  key: 1,
  class: "position"
}
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "fas fa-phone-alt icon"
}
const _hoisted_12 = {
  key: 1,
  class: "position"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"auto"} }, null, -1))
const _hoisted_14 = { class: "other-details" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-building icon" }, null, -1))
const _hoisted_16 = { class: "text" }
const _hoisted_17 = { class: "other-details" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-hashtag icon" }, null, -1))
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "other-details" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-hashtag icon" }, null, -1))
const _hoisted_22 = { class: "text" }
const _hoisted_23 = { class: "other-details" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-globe icon" }, null, -1))
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { class: "other-details" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-map-marker-alt icon" }, null, -1))
const _hoisted_28 = { class: "text" }
const _hoisted_29 = { class: "other-details" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt icon" }, null, -1))
const _hoisted_31 = { class: "text" }
const _hoisted_32 = { class: "other-details" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope icon" }, null, -1))
const _hoisted_34 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_BusinessLogo = _resolveComponent("BusinessLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Avatar, { src: _ctx.agentAvatar }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currentTenantReview?.user?.first_name) + " " + _toDisplayString(_ctx.currentTenantReview?.user?.last_name), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.hasEmail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.hasEmail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.currentTenantReview?.user.email), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.hasMobileNumber)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : _createCommentVNode("", true),
              (_ctx.hasMobileNumber)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$filters.formatMobile(_ctx.currentTenantReview?.user.mobile_number)), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_13,
        (_ctx.hasLogo)
          ? (_openBlock(), _createBlock(_component_BusinessLogo, {
              key: 0,
              imageSrc: _ctx.getBusinessLogo,
              fill: "scale-down",
              height: "34px"
            }, null, 8, ["imageSrc"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.currentTenantReview?.user?.business_name || '"No Business Name"'), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formattedAbn || '"No ABN"'), 1)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formattedAcn || '"No ACN"'), 1)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.currentTenantReview?.user?.business_website || '"No Website"'), 1)
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.address || '"No Address"'), 1)
    ]),
    _createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$filters.formatPhone(
          _ctx.currentTenantReview?.user?.business_phone_number
        ) || '"No Phone Number"'), 1)
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.currentTenantReview?.user?.business_email_address ||
        '"No Email Address"'), 1)
    ])
  ]))
}